import { api } from "@/lib/api";

export function getVisitorId() {
  let v = localStorage.getItem("crerea-vid");
  if (!v) {
    v = "v_" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
    localStorage.setItem("crerea-vid", v);
  }
  return v;
}

export function trackVisit(path) {
  try {
    api.post("/track", { path, visitor: getVisitorId(), ref: document.referrer || "" }).catch(() => {});
  } catch { /* ignore */ }
}
